module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/projects/detail/project-detail-main/project-detail-main.component.scss
// module id = ./src/app/projects/detail/project-detail-main/project-detail-main.component.scss
// module chunks = main